export const generalPaths = {
  // for notifications module in side bar
  notificationsLogs: "/notification-logs",
  // for the notifications View All button in header dropdown
  dropdownNotifications: "/notifications-logs",
};

export const motorPaths = {
  fnol: "/fnol",
};
